import React from 'react';

import Layout from 'Global/Layout';
import SEO from 'Global/SEO';
import Hero from 'Global/Hero/Hero';
import TextContent from 'Component/TextContent/TextContent';
import CtaSection from 'Component/CtaSection/CtaSection';
import MultiColumnFeature from 'Component/MultiColumnFeature/MultiColumnFeature';

import IconsData from 'IconsData/Partner.json';
import { PartnerHero } from 'TextContentData/Partner/PartnerHero.js';
import Working from 'TextContentData/Partner/Working.json';
import WhyPartner from 'TextContentData/Partner/WhyPartner.json';
import MultiColumnFeatureData from 'MultiColumnFeatureData/Partner.json';

const Partner = () => {
	return (
		<Layout>
			<SEO title="Partner with us" description="" />
			<Hero
				heading="Partner with Us"
				description="We offer a comprehensive technology solution"
				iconsData={IconsData}
				ctaFormText="Interested in Moneyfront's Corporate Treasury service?"
				customClass="bgPartner"
			/>
			<TextContent
				data={PartnerHero}
				customClass="partnerOverlap"
				expand="expandMobile"
			/>
			<TextContent
				heading="How does it work?"
				data={Working}
				customClass="whyInternationalStocks"
			/>
			<MultiColumnFeature
				heading="Who can become a Moneyfront Partner?"
				description="Our Mutual Fund Investment Tech Platform can be used by:"
				data={MultiColumnFeatureData}
				customClass="partner"
			/>
			<TextContent data={WhyPartner} customClass="whyPartner" />
			<CtaSection
				heading="Ready to turn digital? Let’s partner!"
				customClass="inFooter"
			/>
		</Layout>
	);
};

export default Partner;
